<script>
import { defineComponent } from 'vue'
import CardWrapper from "../../Shared/CardWrapper.vue";

export default defineComponent({
    name: "InRetailDashboardLockedOut",
    components: { CardWrapper },
    props: {
        locked_out_date: {
            type: String,
            required: true,
        },
    },
})
</script>

<template>
    <card-wrapper :title="Lang.get('employerdashboard::pages/dashboard/in_retail_dashboard_locked_out.title')"
                  :subtitle="Lang.get('employerdashboard::pages/dashboard/in_retail_dashboard_locked_out.intro')">
        <div class="col-12 card h-100 border-radius-8 border-0 shadow">
            <div class="card-body"
                 v-html="Lang.get('employerdashboard::pages/dashboard/in_retail_dashboard_locked_out.message', {
                     from: locked_out_date,
                 })"


            />
        </div>
    </card-wrapper>
</template>
